import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import DataViewer from '../core/data-viewer';
import SearchTableWithSort from '../app/search-tablewithsort';
import ServicesExportPanelAction from '../app/services-export-panel-action';

// Containers
import withSearch from '../../containers/with-search';

const servicesDataKey = 'catalogItemsMissingEid';

class CatalogItemsMissingEid extends Component {
    getColumnConfig() {
        return [
            {
                dataKey: 'name',
                title: 'Title',
                width: '40%',
            },
            {
                dataKey: 'dataPackages.0.networkName',
                title: 'Network',
                width: '36%',
            },
            {
                dataKey: 'dataPackages.0.startDate',
                title: 'Start Date',
                type: 'date',
                parseFormat: 'x',
                width: '12%',
            },
            {
                dataKey: 'dataPackages.0.endDate',
                title: 'End Date',
                type: 'date',
                parseFormat: 'x',
                width: '12%',
            },
        ];
    }

    getRowDetails() {
        return {
            component: DataViewer,
            componentProps: {
                defaultExpandKeys: ['dataPackages'],
            },
        };
    }

    getTablewithsortProps() {
        return {
            columnConfig: this.getColumnConfig(),
            formName: servicesDataKey,
            rowDetails: this.getRowDetails(),
            servicesDataKey,
            localSort: true,
            ...this.props,
        };
    }

    render() {
        const {searchData} = this.props;

        return (
            <div className="catalog-items-missing-eid">
                <ServicesExportPanelAction parentKeys={['dataPackages.0.startDate']} searchData={searchData} />
                <SearchTableWithSort {...this.getTablewithsortProps()} />
            </div>
        );
    }
}

CatalogItemsMissingEid.propTypes = {
    searchData: PropTypes.array,
    tableWithSortProps: PropTypes.object,
};

export default withSearch(CatalogItemsMissingEid, servicesDataKey);
